import * as React from 'react';

import cx from 'classnames';
import style from './Footer.css';
import { Link, Route } from 'react-router-dom';

import IconTwitter from './icons/twitter.inline.svg';
import IconFacebook from './icons/facebook.inline.svg';
import IconMedium from './icons/medium.inline.svg';
import IconYoutube from './icons/youtube.inline.svg';
import PrivacyPolicy from '../Files/pdf/privacy_policy.pdf';
import TermsOfUse from '../Files/pdf/terms_of_use.pdf';

import { NextPage } from 'components/NextPage';

const File = (props) => (
    <li><a className={style.articleLink} target="_blank" href={props.file}>
        {props.title}
    </a></li>
);

export const Footer = ({ className }) => (
  <footer className={cx(style.root, className)}>
        <Route exact path='/' render={(props) => (
            <NextPage
                label={"Team page"}
                to="/team"
                className={style.nextPage}
            />
        )}/>

        <Route path='/resources' render={() => (
            <NextPage
                label={"Contact page"}
                to="/contact"
                className={style.nextPage}
            />
        )}/>

        <Route path='/team' render={() => (
            <NextPage
                label={"Resources page"}
                to="/resources"
                className={style.nextPage}
            />
        )}/>

        <div className={style.content}>
            <div className={cx('container')}>
                <ul className={cx(style.social, style.list)}>
                    <li className={style.socialItem}>
                        <a href="https://twitter.com/block_science" target="_blank">
                            <IconTwitter className={style.socialIcon}/>
                        </a>
                    </li>
                    <li className={style.socialItem}>
                        <a href="https://blockscience.ghost.io/" target="_blank">
                            <IconMedium className={style.socialIcon}/>
                        </a>
                    </li>
                    <li className={style.socialItem}>
                        <a href="https://www.facebook.com/BlockScience/" target="_blank">
                            <IconFacebook className={style.socialIcon}/>
                        </a>
                    </li>
                    <li className={style.socialItem}>
                        <a href="https://www.youtube.com/channel/UCPePNv3dJN--aKhFGOa0Rjg" target="_blank">
                            <IconYoutube className={style.socialIcon}/>
                        </a>
                    </li>
                </ul>
                <nav className={style.nav}>
                    <section className={style.column}>
                        <h6>company</h6>
                        <ul className={cx(style.navList, style.list)}>
                            <li className={style.navItem}><Link className={style.link} to="/history">History</Link></li>
                            <li className={style.navItem}><Link className={style.link} to="/team">Team</Link></li>
                            <li className={style.navItem}><Link className={style.link} to="/resources">Resources</Link>
                            </li>
                            <li className={style.navItem}><a className={style.link} target="_blank" href="https://blockscience.ghost.io/">blog</a></li>
                            <li className={style.navItem}><a className={style.link} target="_blank" href="http://cadcad.org">cadCAD</a></li>
                        </ul>
                    </section>
                    <section className={style.column}>
                        <h6>info</h6>
                        <ul className={cx(style.navList, style.list)}>
                            <li className={style.navItem}>
                                <Link className={style.link} to={{
                                    pathname: "/contact",
                                    state: {scrollTo: true}
                                }}>
                                    GET IN TOUCH
                                </Link>
                            </li>
                            <li className={style.navItem}>
                                <File file={PrivacyPolicy} title='Privacy Policy' />
                            </li>
                            <li className={style.navItem}>
                                <File file={TermsOfUse} title='Terms of Use' />
                            </li>
                        </ul>
                    </section>
                </nav>
            </div>
            <div className={cx(style.copyright, 'container')}>
                <p>© 2023 Block Science, Inc. All rights reserved.</p>
                <a href="http://magicpowered.com.ua/" target="_black" className={style.made}>Made by Magic Powered
                    company.<i className={style.magicLogo}>MP</i></a>
            </div>
        </div>
    </footer>
);
